import { ADD_NEW_FAMILY, ADD_NEW_FAMILY_ERROR, ADD_NEW_FAMILY_SUCCESS, DELETE_FAMILY_MEMBER, FAMILY_TREE, FAMILY_TREE_ERROR, FAMILY_TREE_SUCCESS, GET_COUNTRIES, GET_COUNTRIES_ERROR, GET_COUNTRIES_SUCCESS, PATIENT_DETAILS, PATIENT_DETAILS_ERROR, PATIENT_DETAILS_SUCCESS, PROFILE_FAMILY_GET, UPDATE_FAMILY_MEMBER, UPDATE_FAMILY_MEMBER_ERROR, UPDATE_FAMILY_MEMBER_SUCCESS } from './Constant';

export const patientDetailsRequest = (id) => ({
    type: PATIENT_DETAILS,
    payload: id,
});

export const patientDetailsRequestSuccess = (payload) => ({
    type: PATIENT_DETAILS_SUCCESS,
    payload: payload
});

export const patientDetailsRequestError = () => ({
    type: PATIENT_DETAILS_ERROR,
});

export const familyTreeRequest = () => ({
    type: FAMILY_TREE,
});

export const familyTreeRequestSuccess = (payload) => ({
    type: FAMILY_TREE_SUCCESS,
    payload: payload
});

export const familyTreeRequestError = () => ({
    type: FAMILY_TREE_ERROR,
});

export const profileFamilyRequest = (payload) => ({
    type: PROFILE_FAMILY_GET,
    userId : payload
});

export const getCountriesRequest = () => ({
    type: GET_COUNTRIES,
});

export const getCountriesRequestSuccess = (payload) => ({
    type: GET_COUNTRIES_SUCCESS,
    payload : payload
});

export const getCountriesRequestError = () => ({
    type: GET_COUNTRIES_ERROR,
});


export const addNewFamilyRequest = (value, initials) => ({
    type: ADD_NEW_FAMILY,
    value : value,
    initials : initials
});

export const addNewFamilyRequestSuccess = (payload) => ({
    type: ADD_NEW_FAMILY_SUCCESS,
    payload : payload
});

export const addNewFamilyRequestError = () => ({
    type: ADD_NEW_FAMILY_ERROR,
});

export const deleteFamilyMember = (id) => ({
    type: DELETE_FAMILY_MEMBER,
    payload: id,
});

export const updateFamilyMemberRequest = (data, memberId, image) => ({
    type: UPDATE_FAMILY_MEMBER,
    payload: {
        data,
        memberId,
        image
    },
});

export const updateFamilyMemberSuccess = (payload) => ({
    type: UPDATE_FAMILY_MEMBER_SUCCESS,
    payload,
});

export const updateFamilyMemberError = (error) => ({
    type: UPDATE_FAMILY_MEMBER_ERROR,
    error,
});